<template>
	<div>
		<v-label v-if="label">{{ label }}</v-label>
		<template v-if="helpTextTooltip">
			<v-tooltip location="top" no-click-animation>
				<template v-slot:activator="{ props }">
					<v-icon v-bind="props" size="20" style="color: #00aeef;">mdi-help-circle</v-icon>
				</template>
				<span v-html="helpText"></span>
			</v-tooltip>
		</template>
		<p v-else>{{ helpText }}</p>
		<v-select
			v-model="internalValue"
			:items="options"
			:placeholder="placeholder"
			:item-title="(item) => item.title?.[serviceLocale] || item.title"
			:item-value="returnObject ? undefined : 'value'"
			:return-object="returnObject"
			:data-cy="dataCy"
			density="compact"
			variant="outlined"
			:hide-details="!errorMessages?.length"
			:error-messages="errorMessages"
			:clearable="celarable"
			:disabled="disabled"
			:menu-props="{ closeOnContentClick: true, contentClass: menuClass }"
		>
			<template v-slot:item="{ props, item }">
				<v-list-item v-bind="props">
					<template v-slot:prepend>
						<v-radio
							:model-value="isItemSelected(item.raw)"
							readonly
						/>
					</template>
				</v-list-item>
				<v-divider />
			</template>
			<template v-slot:append-item>
				<slot name="append-option"></slot>
			</template>
		</v-select>
	</div>
</template>

<script>
import Common from '@/mixins/Common.vue'

export default {
	name: 'RadioSelect',
	mixins: [Common],
	props: {
		modelValue: [String, Object],
		options: Array,
		placeholder: String,
		label: String,
		helpText: String,
		helpTextTooltip: Boolean,
		dataCy: String,
		celarable: Boolean,
		disabled: Boolean,
		returnObject: {
			type: Boolean,
			default: false
		},
		errorMessages: {
			type: Array,
			default: () => []
		},
		// the menu is teleported to <body>, so scoped styles of the parent cannot reach it: style this class instead
		menuClass: String,
	},
	computed: {
		internalValue: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		}
	},
	methods: {
		isItemSelected(item) {
			if (!this.internalValue) return false

			if (this.returnObject) {
				// Compare objects by stringifying them
				return JSON.stringify(this.internalValue) === JSON.stringify(item)
			} else {
				// For simple values, direct comparison
				return this.internalValue === item.value
			}
		}
	}
}
</script>
